<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.KeepAlive && drawPage" />
    </keep-alive>
    <router-view v-if="!$route.meta.KeepAlive && drawPage" />
    <!-- 充值弹框 -->
    <TopUp />
    <!-- 邀请弹框 -->
    <InviteDialog />
    <!-- sse任务推流弹框 -->
    <SseNotification />
    <!-- iframe登录组件 -->
    <LoginDialog />
    <!-- 升级通知弹框 -->
    <UpgradeNotification :show.sync="showUpgrade" />
  </div>
</template>

<script>
import { getSocket, forceReconnect, isConnected } from "@/utils/websocket";
import { mapActions, mapGetters } from "vuex";
import TopUp from "./components/TopUp.vue";
import InviteDialog from "./components/InviteDialog";
import SseNotification from "./components/sseNotification";
import "../src/assets/css/all.min.css";
import LoginDialog from "./components/loginDialog.vue";
import { getCookieVal } from "@/tool/index";
import UpgradeNotification from "./components/upgradeNotification.vue";
export default {
  name: "App",
  components: {
    TopUp,
    InviteDialog,
    SseNotification,
    LoginDialog,
    UpgradeNotification,
  },
  data() {
    return {
      visible: true,
      drawPage: false,
      upgradePages: [], // 升级提示页面
      showUpgrade: false, // 是否显示升级提示
    };
  },
  computed: {
    ...mapGetters(["token"]),
  },
  watch: {
    token(val) {
      // 弹框登录后重新连接websocket
      forceReconnect();
    },
    $route(to) {
      let routePath = this.$route.path;
      if (this.upgradePages.includes(routePath)) {
        this.showUpgrade = true;
      }
    },
  },
  created() {
    // 获取apollo配置，可以动态添加key获取相应的配置数据
    // 数据将被存储来 vuex 中 apolloConfig
    // 使用 vuex getters 获取 指定的配置数据
    this.getConfig();
    this["toolConfig/getCaseConfig"]();
  },
  mounted() {
    if (getCookieVal("iyuanwu_token")) {
      getSocket();
    }
    // 页面激活时检查 WebSocket 是否断开，断开则重连
    this._onVisibilityChange = () => {
      if (document.visibilityState === "visible" && !isConnected()) {
        forceReconnect();
      }
    };
    document.addEventListener("visibilitychange", this._onVisibilityChange);
  },
  beforeDestroy() {
    if (this._onVisibilityChange) {
      document.removeEventListener(
        "visibilitychange",
        this._onVisibilityChange
      );
    }
  },
  methods: {
    ...mapActions([
      "getApolloConfig",
      "toolConfig/getCaseConfig", // 获取工具所有案例配置
    ]),
    // 获取apollo配置
    async getConfig() {
      if (this.$route.meta && this.$route.meta.skipApollo) {
        this.drawPage = true;
        return;
      }
      this.drawPage = false;
      await this.getApolloConfig({
        keys: [
          "ai_clothing_type",
          "model_options", // 通道生成模型配置
          "ai_video",
          "ai_agent_tool_config", // 爆款出图agent工具名称和loading对应配置
          "ai_imitation_prompt", // 爆款出图引导语配置
          "vector_search_merge_category", // 向量搜索分类配置
          "ai_gpt_tool_channel", // GPT 模型配置
          "optimize_write_prompt", // 是否开启提示词优化
          "ai_agent_page", // ai agent 页面配置
        ],
      });
      this.drawPage = true;
    },
  },
};
</script>

<style lang="scss">
body {
  height: 100%;
  width: 100%;
}

/* canvas {
  cursor: none !important;
} */

#app {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.el-image-viewer__wrapper {
  &::after {
    position: absolute;
    bottom: 3px;
    font-size: 12px;
    left: 50%;
    color: #fff;
    transform: translate(-50%, 0);
    display: inline-block;
    text-align: center;
    height: 24px;
    padding: 0 16px;
    border-radius: 12px;
    line-height: 24px;
    background-color: #606266;
    width: 972px;
    content: "版权提醒：由于AI生成作品受用户指令生成，因此爱原物不保证AI生成作品的合法性，用户仍应当自行判断AI生成作品内容的合法性，并自行承担使用AI生成作品可能引发的法律责任。";
  }
}
</style>
